import _ from "lodash";
import React from "react";
import useI18n from "Hooks/UseI18n";

import {
  Dropdown,
  IconDisclosure,
  DropdownMenu,
  DSProvider,
} from "@toddle-edu/ds-web";
import {
  getPortfolioTypeDropOptions,
  bulkApplyColumnAction,
} from "../../../modules/TeacherPortfolioModule";
import PortfolioInfoTooltip from "../PortfolioInfoTooltip";
const styles = {
  overlayInnerStyle: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "10px",
  },
  itemContainerStyle: {
    maxWidth: "340px",
    whiteSpace: "normal",
  },
};

const BulkApplyColumnAction = props => {
  const {
    columnId,
    showHeader = true,
    selectedValue,
    onChange,
    changedData,
    setChangedData,
    dispatch,
    containerRef,
    isEditMode,
    showSubLevelOptions = true,
  } = props;
  const { t } = useI18n();
  const moduleAccessOptions = getPortfolioTypeDropOptions({
    t,
  });
  const label = (
    <div className={"text-label-2"}>{t("journal:bulk_action_label")}</div>
  );

  const moduleAccessOptionsWithoutSublevel = _.map(
    moduleAccessOptions,
    option => {
      const { subText, ...optionFields } = option;
      return optionFields;
    }
  );
  const moduleAccessBulkApplyItemGroup = [
    {
      isItemGroup: true,
      key: "BULK_APPLY",
      label: label,
      options: moduleAccessOptions,
    },
  ];

  const applyGradeSetting = ({ key }) => {
    if (!showHeader) onChange({ key, grade: columnId });
    else {
      const payload = {
        key,
        grade: columnId,
        changedData,
        setChangedData,
      };

      dispatch(bulkApplyColumnAction(payload));
    }
  };

  const getPopupContainer = () => document.body;
  return (
    <div style={styles.overlayInnerStyle}>
      {showHeader ? <PortfolioInfoTooltip containerRef={containerRef} /> : null}
      {isEditMode ? (
        <DSProvider dsVersion="2.0">
          <Dropdown
            overlay={
              <DropdownMenu
                options={
                  showHeader
                    ? moduleAccessBulkApplyItemGroup
                    : showSubLevelOptions
                    ? moduleAccessOptions
                    : moduleAccessOptionsWithoutSublevel
                }
                showSelection
                selectionType="tick"
                value={selectedValue}
                onClick={applyGradeSetting}
                hasMultilineOptions
                itemTitleContainerStyle={styles.itemContainerStyle}
              />
            }
            getPopupContainer={getPopupContainer}
            placement={"bottomRight"}
          >
            <IconDisclosure variant="neutral" size={"small"} type="plain" />
          </Dropdown>
        </DSProvider>
      ) : null}
    </div>
  );
};

export default BulkApplyColumnAction;
